import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText, MediumText, SelectOption, TextAreaBox, TextBox } from '@guryou/html-components';
import { stateIsLoading, useGender, useServiceCategories } from '@guryou/redux';
import GenderRadio from 'onboard/components/GenderRadio';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';

import StepButtons from '../StepButtons';

const ServiceGeneralInformation = () => {
  const { t } = useTranslation();
  const { serviceState, setServiceState } = useOnboardContext();
  const genderOptions = useGender(true);

  const categories = useServiceCategories({ type: 'service' });

  const handleSubmit = data => {
    setServiceState(data);
  };

  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t('ONBOARD.serviceTitle')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <TextBox
            xs={12}
            fullWidth
            label={t('ONBOARD.serviceName')}
            margin="10px 0px 20px 0px"
            name="serviceName"
            value={serviceState.serviceName}
            required
          />
          <TextAreaBox
            xs={12}
            fullWidth
            rows="6"
            margin="10px 0px 20px 0px"
            required
            name="description"
            label={t('ONBOARD.description')}
            value={serviceState.description}
          />
          <SelectOption
            name="svcTypeId"
            disabled={stateIsLoading(categories)}
            xs={12}
            required
            fullWidth
            label={t('ONBOARD.category')}
            value={serviceState.svcTypeId}
            margin="10px 0px 20px 0px"
            none={false}
            options={categories?.data}
          />
          <GenderRadio options={genderOptions} value={serviceState.target} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText>{t('ONBOARD_TEXT.serviceGeneralInformationTitle')}</MediumText>
        <DefaultText fontSize="1.2rem">{t('ONBOARD_TEXT.serviceGeneralInformationSubtitle')}</DefaultText>
        <Block margin={0} marginTop={10}>
          <DefaultText fontSize="1.2rem" fontWeight="800">
            {t('ONBOARD_TEXT.serviceGeneralInformationCheckboxTitle')}
          </DefaultText>
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceGeneralInformationCheckbox1Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceGeneralInformationCheckbox2Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceGeneralInformationCheckbox3Text')} />
        </Block>
        <PlayGuideVideoEmbed videoId={guideVideos.serviceGeneralInfo.videoId} modalTitle={guideVideos.serviceGeneralInfo.title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default ServiceGeneralInformation;
